import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root');

const hideInitialLoader = () => {
    const initialLoader = document.getElementById('initial-loader');
    if (initialLoader) {
        initialLoader.style.transition = 'opacity 0.3s ease-out';
        initialLoader.style.opacity = '0';
        setTimeout(() => {
            if (initialLoader.parentNode) {
                initialLoader.remove();
            }
        }, 300);
    }
    if (container) {
        container.setAttribute('data-react-mounted', 'true');
    }
};

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        setTimeout(hideInitialLoader, 50);
    });
});
